import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
export const sortType_RecentlyAdded = {
    label: 'Recently Added',
    objectSortingProp: ['__created']
};
export const sortType_Ascending = {
    label: 'Ascending',
    objectSortingProp: ['label', 'name']
};
export const sortType_Descending = {
    label: 'Descending',
    objectSortingProp: ['label', 'name'],
    invert: true,
};
export const storageKey_SearchAndResult_SelectedSort = new StorageKey('storageKey_selectedSort');
//# sourceMappingURL=consts.js.map